import * as React from 'react'
import { createIcon } from './createIcon'
import { IconOptions } from './icon-options'

function IconContent({ color }: IconOptions) {
  return (
    <React.Fragment>
      <rect width='24' height='24' />
      <path
        d='M18.9971 6.00586L14.3323 8.40346L9.66763 6.00586L5.0029 8.40346V17.9939L9.66763 15.5963L14.3323 17.9939L18.9971 15.5963V6.00586Z'
        stroke={color}
        strokeMiterlimit='10'
        strokeLinejoin='round'
      />
      <path d='M14.3325 8.4043V17.9947' stroke={color} strokeMiterlimit='10' />
      <path d='M9.66748 6.00586V15.5963' stroke={color} strokeMiterlimit='10' />
    </React.Fragment>
  )
}

export const MapIcon = createIcon(IconContent)
